import constant from "../constant";

export const DIGITAL_HOME_URL = constant.DIGITAL_BASE_URL.replace(/\/$/, "");
export const DIGITAL_BILLING_URL = `${DIGITAL_HOME_URL}/account/billing`;

export function openDigitalBilling() {
  window.open(DIGITAL_BILLING_URL, "_blank", "noopener,noreferrer");
}

const SI_AUTH_STORAGE_KEYS = [
  "token",
  "ssoToken",
  "resetToken",
  "resetEmail",
  "memberEmail",
];

/** Remove SI / SSO auth tokens from localStorage (keeps other app data). */
export function clearSiAuthStorage() {
  if (typeof window === "undefined") return;
  SI_AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

/** Clear SI auth, then redirect to GE3S Digital home. */
export function redirectToDigitalAfterLogout() {
  if (typeof window === "undefined") return;
  clearSiAuthStorage();
  const redirect = encodeURIComponent(DIGITAL_HOME_URL);
  window.location.replace(`${DIGITAL_HOME_URL}/?logout=1&redirect=${redirect}`);
}
